export default "__VITE_ASSET__CDj0AH2Z__"